import { c as _c } from "react/compiler-runtime";
import { getCountryNameFromCode } from '@onefootprint/core';
import { useTranslation } from 'react-i18next';
import TextList from '@/components/text-list';
import Item from '@/playbook-builder/components/item';
import Section from '@/playbook-builder/components/section';
import SubSection from '@/playbook-builder/components/sub-section';
import type { CollectDataNodeProps, IdentityDataNodeProps } from '@/playbook-builder/playbook-builder.types';
import { collectsData, isDataOptional } from '../utils/data-collection-utils';
type ResidencyViewProps = {
  node: CollectDataNodeProps | IdentityDataNodeProps;
};
const ResidencyView = t0 => {
  const $ = _c(48);
  const {
    node
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "collectData.person.residency"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("playbook-builder", t1);
  let T0;
  let T1;
  let T2;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[1] !== node.data || $[2] !== t) {
    const isOptional = isDataOptional(node.data);
    const collects = collectsData(node.data);
    const renderTaxIdValue = () => {
      if (collects("us_tax_id")) {
        return isOptional("us_tax_id") ? t(_temp) : t(_temp2);
      }
      if (collects("ssn9")) {
        return isOptional("ssn9") ? t(_temp3) : t(_temp4);
      }
      if (collects("ssn4")) {
        return isOptional("ssn4") ? t(_temp5) : t(_temp6);
      }
      return false;
    };
    T2 = Section;
    if ($[12] !== t) {
      t6 = t(_temp7);
      $[12] = t;
      $[13] = t6;
    } else {
      t6 = $[13];
    }
    let t8;
    if ($[14] !== t) {
      t8 = t(_temp8);
      $[14] = t;
      $[15] = t8;
    } else {
      t8 = $[15];
    }
    let t9;
    if ($[16] !== t) {
      t9 = t(_temp9);
      $[16] = t;
      $[17] = t9;
    } else {
      t9 = $[17];
    }
    let t10;
    if ($[18] !== node.data.residentialAddressCountries) {
      t10 = node.data.residentialAddressCountries?.map(_temp10);
      $[18] = node.data.residentialAddressCountries;
      $[19] = t10;
    } else {
      t10 = $[19];
    }
    let t11;
    if ($[20] !== t10) {
      t11 = <TextList items={t10} />;
      $[20] = t10;
      $[21] = t11;
    } else {
      t11 = $[21];
    }
    let t12;
    if ($[22] !== t11 || $[23] !== t9) {
      t12 = <Item label={t9} value={t11} />;
      $[22] = t11;
      $[23] = t9;
      $[24] = t12;
    } else {
      t12 = $[24];
    }
    if ($[25] !== t12 || $[26] !== t8) {
      t7 = <SubSection title={t8}>{t12}</SubSection>;
      $[25] = t12;
      $[26] = t8;
      $[27] = t7;
    } else {
      t7 = $[27];
    }
    T1 = SubSection;
    if ($[28] !== t) {
      t4 = t(_temp11);
      $[28] = t;
      $[29] = t4;
    } else {
      t4 = $[29];
    }
    let t13;
    if ($[30] !== t) {
      t13 = t(_temp12);
      $[30] = t;
      $[31] = t13;
    } else {
      t13 = $[31];
    }
    t5 = <Item label={t13} value={renderTaxIdValue()} />;
    T0 = Item;
    if ($[32] !== t) {
      t2 = t(_temp13);
      $[32] = t;
      $[33] = t2;
    } else {
      t2 = $[33];
    }
    t3 = collects("us_legal_status");
    $[1] = node.data;
    $[2] = t;
    $[3] = T0;
    $[4] = T1;
    $[5] = T2;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    T0 = $[3];
    T1 = $[4];
    T2 = $[5];
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
    t5 = $[9];
    t6 = $[10];
    t7 = $[11];
  }
  let t8;
  if ($[34] !== T0 || $[35] !== t2 || $[36] !== t3) {
    t8 = <T0 label={t2} value={t3} />;
    $[34] = T0;
    $[35] = t2;
    $[36] = t3;
    $[37] = t8;
  } else {
    t8 = $[37];
  }
  let t9;
  if ($[38] !== T1 || $[39] !== t4 || $[40] !== t5 || $[41] !== t8) {
    t9 = <T1 title={t4}>{t5}{t8}</T1>;
    $[38] = T1;
    $[39] = t4;
    $[40] = t5;
    $[41] = t8;
    $[42] = t9;
  } else {
    t9 = $[42];
  }
  let t10;
  if ($[43] !== T2 || $[44] !== t6 || $[45] !== t7 || $[46] !== t9) {
    t10 = <T2 title={t6}>{t7}{t9}</T2>;
    $[43] = T2;
    $[44] = t6;
    $[45] = t7;
    $[46] = t9;
    $[47] = t10;
  } else {
    t10 = $[47];
  }
  return t10;
};
export default ResidencyView;
function _temp($) {
  return $.countries.us.taxId.ssnOrItinOptional;
}
function _temp2($_0) {
  return $_0.countries.us.taxId.ssnOrItin;
}
function _temp3($_1) {
  return $_1.countries.us.taxId.ssn9Optional;
}
function _temp4($_2) {
  return $_2.countries.us.taxId.ssn9;
}
function _temp5($_3) {
  return $_3.countries.us.taxId.ssn4Optional;
}
function _temp6($_4) {
  return $_4.countries.us.taxId.ssn4;
}
function _temp7($_5) {
  return $_5.title;
}
function _temp8($_6) {
  return $_6.countries.title;
}
function _temp9($_7) {
  return $_7.countries.label;
}
function _temp10(code) {
  return getCountryNameFromCode(code);
}
function _temp11($_8) {
  return $_8.countries.us.title;
}
function _temp12($_9) {
  return $_9.countries.us.taxId.readOnlyLabel;
}
function _temp13($_10) {
  return $_10.countries.us.legalStatus.label;
}